var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0246 12.0561C26.6182 12.0561 26.2903 12.3839 26.2903 12.7895V16.5722H3.70968V7.37014C3.70968 6.96459 3.3809 6.63672 2.97626 6.63672H1.73342C1.32877 6.63672 1 6.96459 1 7.37014V23.0637C1 23.4701 1.32877 23.798 1.73342 23.798H2.97626C3.3809 23.798 3.70968 23.4701 3.70968 23.0646V21.0883H26.2903V23.0646C26.2903 23.4701 26.6182 23.798 27.0246 23.798H28.2666C28.6721 23.798 29 23.4701 29 23.0646V12.7895C29 12.3839 28.6721 12.0561 28.2666 12.0561H27.0246Z",
    fill: "#DF0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25751 14.7059C8.7226 14.7059 9.91028 13.5183 9.91028 12.0532C9.91028 10.5881 8.7226 9.40039 7.25751 9.40039C5.79242 9.40039 4.60474 10.5881 4.60474 12.0532C4.60474 13.5183 5.79242 14.7059 7.25751 14.7059Z",
    fill: "#DF0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8011 9.38494C13.0704 9.30907 12.3415 9.54752 11.7959 10.0398C11.2504 10.5311 10.936 11.232 10.936 11.9664V14.7655H25.5195C24.4664 12.6745 20.2953 10.0551 13.8011 9.38494Z",
    fill: "#DF0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.590261a66d08fd81fc3bf57dad8fbce9.svg";
export { ForwardRef as ReactComponent };